import { Component, computed, inject, input, ViewEncapsulation } from '@angular/core';

import { CANVAS_ICONS_BASE_URL } from '../canvas-icons.constants';

@Component({
  selector: 'lib-canvas-toolbar-icon',
  standalone: true,
  template: `
    <img
      class="cv-toolbar-icon-img"
      [class]="hostClass()"
      [src]="src()"
      width="24"
      height="24"
      alt=""
      loading="lazy"
    />
  `,
  encapsulation: ViewEncapsulation.None,
})
export class CanvasToolbarIconComponent {
  private readonly baseUrl = inject(CANVAS_ICONS_BASE_URL);

  /** File name without `.svg` under `libs/feature/src/lib/canvas/icons` (published as package `icons/`). */
  readonly name = input.required<string>();

  /** Extra CSS classes on the img (e.g. size variants from toolbar SCSS). */
  readonly imgClass = input<string>('');

  readonly src = computed(() => {
    const base = this.baseUrl.replace(/\/$/, '');
    return `${base}/${this.name()}.svg`;
  });

  readonly hostClass = computed(() => {
    const extra = this.imgClass().trim();
    return extra ? `cv-toolbar-icon-img ${extra}` : 'cv-toolbar-icon-img';
  });
}
